import React from 'react';
import PropTypes from 'prop-types';

import { useUser } from '@/contexts/UserContext';

function KeysAddressSection({ address }) {
  const me = useUser();
  const isColombianFranchisee = me?.profile?.country === 'CO';

  if (!address) return null;

  return (
    <div className="mt-[0.5vw]">
      {!isColombianFranchisee && address.zipcode && (
        <div className="text-[#858585] text-[calc(6px+0.4vw)] mb-[0.5vw]" data-cy="order-details-keys-address-zipcode">
          {address.zipcode}
        </div>
      )}
      
      <div className="text-[#858585] text-[calc(6px+0.4vw)] mb-[0.5vw]" data-cy="order-details-keys-address-street-number-complement">
        {address.street}, {address.number}
        {address.complement && (
          <span>
            <span>, </span>
            {address.complement}
          </span>
        )}
      </div>

      <div className="text-[#858585] text-[calc(6px+0.4vw)] mb-0" data-cy="order-details-keys-address-neighborhood-city-state">
        {address.neighborhood}, {address.city} - {address.state}
      </div>
    </div>
  );
}

KeysAddressSection.propTypes = {
  address: PropTypes.object.isRequired,
};

export default KeysAddressSection;
